// extracted by mini-css-extract-plugin
export default {"wrapper":"MessageGroup_wrapper__E5AX5","modalImg":"MessageGroup_modalImg__F6lI9"};